import { request } from 'tools'

export const getLinks = params => request.get( 'links', params )